import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import {
  useCreateOrdenesCompra,
  usefetchProveedor,
  useGetSolicitudesIngreso,
  useFetchPaymentMethodsParamsProveedor,
  useGetSolicitudIngreso,
  useFetchOrdenesCompras,
  useUpdateSolicitudesIngresos,
  useFetchProductos,
  useUpdateProveedor,
  useUpdateOrdenesCompra,
} from "@/shared/actions/erp";
import {
  CustomAutocomplete,



  CustomTextField,


  SampleCheckboxNoForm,
  SampleDatePicker,
  SingleTableBoxScene,
  TabTextLabel
} from "@/shared/components/ui";
import {

  PROVEEDOR,
  IPaymentMethod,
  SolicitudesIngreso,
  EstadosSolicitudPeodidoEnum,
  MaterialTransferido,
  AlertSeverityEnum,

  solicitud_ingreso,
  EstadosSolicitudIngresoEnum,


} from "@/shared/interfaces";
import { CircularProgress, Grid, Paper, TextField, Typography } from "@mui/material";
import { BucketAwtENUM, gridSize, gridSizeMdLg4, ROUTER_PATHS, TipoFormaPagoEnumChoice, useUploadFile } from "@/shared";
import { useUiStore } from "@/store/ui";
import { newOrdenesCompraSchema } from "@/shared";
import dayjs from "dayjs";

import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import useTableColumnsOrdenCompra from "@/shared/hooks/useTableColumnsOrdenCompra";

import CargarDocumentoSoluccionCosteada from "@/erp/venta-corporativa/solucion_costeada/shared/componente/cargar_documento_soluccion_costeada/CargarDocumentoSoluccionCosteada";
import { OrdenesCompra } from "@/shared/interfaces/erp/compras/ordenes-compra.interface";
import SampleTablePaginationOrden from "@/shared/components/ui/SampleTablePaginationOrden";

import ModalMetodoPagoMixto from "./ModalMetodoPagoMixto";
import CustomModalObservacionForm from "@/shared/components/ui/CustomModalObservacionForm";
import { useMetodoPago } from "@/store/erp";
import { toast } from "react-toastify";
import CustomEmailEditTextFiel from "@/shared/components/ui/CustomEmailEditTextFiel";




export type TipoValores = {
  [codigo: string]: number,

}


const returnUrlOrdenesCompra = "/compras/orden-compras";


type SaveFormData = {

  concepto: string;
  fecha_orden?: string;
  fecha_compra?: string;
  fecha_entrega?: string;
  observaciones?: {
    observacionCreador?: string;
    observacionRevisor?: string;
    observacionCerradoOrden?: string;
  }
  estado_orden?: string;
  detalles?: string;
  plazo_pago: string;
  estado?: string;
  proveedor: string;
  solicitud_ingreso?: string;
  forma_pago: string;
  //
  nombre_proveedor?: string
  email?: string
  contacto_telefono_1?: string
};

export interface SaveOrdenesCompraInterface {
  titlePage: string;
  editOrdenesCompra?: OrdenesCompra;
}

const SaveOrdenesCompra: React.FC<SaveOrdenesCompraInterface> = ({ editOrdenesCompra, titlePage }) => {
  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newOrdenesCompraSchema),
  });
  //hook
  const {
    control,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = form;
  //FILE
  const { handleUploadFile } = useUploadFile()
  //STATE
  const navigate = useNavigate();
  const [shrink, /* setShrink */] = useState(false);
  const [isChecked, setIsChecked] = useState(false)
  const [productosOrden, setProductosOrden] = useState<solicitud_ingreso[]>([])
  const [codigoSeleccionado, setCodigoSeleccionado] = useState('')
  const [idSoliIngreso, setIdSoliIngreso] = useState<string>('')
  const [verifica, setVerifica] = useState(false)
  const [archivo, setArchivo] = useState<File | null>(null)
  const [auxProductos, setAuxProductos] = useState<solicitud_ingreso[]>([])
  const [totalesOrden, setTotalesOrden] = useState({ subtotal: 0, iva: 0, total: 0, totalDescuento: 0, iva_producto: 0 })
  console.log('totalesOrden', totalesOrden)
  const [isModalPago, setIsModalPago] = useState(false)
  const [pagoMixto, setPagoMixto] = useState<string>('')
  const [codigosProductoLista, setCodigosProductosLista] = useState<solicitud_ingreso[]>([])
  const [idEdit, setEdit] = useState('')
  const [editIva, setEditIva] = useState<number | null>(null)
  console.log('editIva', editIva)
  //console.log('iva', editIva)
  //console.log('iva', iva_producto)
  ///
  //console.log('codigo seleccionado', codigoSeleccionado)

  // store
  const setConfirmDialog = useUiStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);
  const setAlert = useUiStore.getState().setAlert;
  const handldeCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const setPagination = useCargarSeriesProductos(s => s.setPagination)
  const pagination = useCargarSeriesProductos(s => s.pagination)
  const metodoPago = useMetodoPago(s => s.metodoPago)
  const clearMetodoPago = useMetodoPago(s => s.clearMetodoPago)
  ///** */
  ///
  //console.log('productos', productos)


  ///
  /*  const fecha_compra = watch(
     "fecha_compra",
     new Date().toISOString().split("T")[0]
   );
   const today = new Date().toISOString().split("T")[0]; */
  const fecha_compra = watch("fecha_compra",
    new Date().toISOString()
  )
  const today = new Date().toISOString()

  // CAPTURO EL ID DE SOLICTUD DE INGRESO
  const { idSolicitudIngreso } = useParams()

  //FETCH
  const {
    data: dataSolicitudIngreso,
    isLoading: isLoadingSolicitudIngreso,
    isRefetching
  } = idSolicitudIngreso ? useGetSolicitudIngreso(idSolicitudIngreso!) : { data: null, isLoading: false, isRefetching: false };

  const { data: dataOrdenCompra, isLoading: isLoadingOrdenCompra } = useFetchOrdenesCompras(
    {
      page_size: 600,
      solicitud_ingreso: form.watch('solicitud_ingreso')
    }, !!form.watch('solicitud_ingreso'))

  ///* fetch data
  const { data: ProveedorPaging, isLoading: isLoadingProveedor } =
    usefetchProveedor({
      page_size: 600,
    });
  const { data: formaPagoPaging, isLoading: isLoadingFormaPagoPaging } =
    useFetchPaymentMethodsParamsProveedor({ page_size: 600 });

  //mutatation
  const createOrdenesCompraMutation = useCreateOrdenesCompra({
    navigate,
    returnUrl: returnUrlOrdenesCompra
  });
  const updateOrdenCompra = useUpdateOrdenesCompra({
    navigate,
    returnUrl: returnUrlOrdenesCompra
  })

  /// para cargar id de solicitud de ingreso
  const {
    data: SolicitudesIngresoPaging,
    isLoading: isLoadingSolicitudesIngresoPaging,
  } = useGetSolicitudesIngreso({
    page_size: 600,
    page: 1,
    estado_solicitud: EstadosSolicitudPeodidoEnum.APROBADAS,
  });
  //update SolicitudCompra
  const updateSolicitudesIngresos = useUpdateSolicitudesIngresos({
    enableSuccessAlert: false
  })
  //
  //const { data: dataProductos, isLoading: isLoadingProductos } = useFetchProductos({})
  const { data: dataProductos, isLoading: isLoadingProductos } = useFetchProductos({
    params: {
      codigos: codigosProductoLista.map(item => item.codigo).join(',')
    },
  })
  //update Proveedor
  const updateProveedor = useUpdateProveedor({
    navigate
  })
  //hook
  const { columnsOrdenCompra } = useTableColumnsOrdenCompra()
  //cuando viene con id
  ////******* cargo lo primero es el codigo para hacer el barrido 
  useEffect(() => {
    if (!idSolicitudIngreso && isLoadingSolicitudIngreso && isRefetching) return;
    form.setValue("solicitud_ingreso", dataSolicitudIngreso?.data.codigo)
  }, [idSolicitudIngreso, dataSolicitudIngreso])
  ////*************le llamo a la funcion de suma cantidad y que sume todo los productos que estan con ese codigo
  useEffect(() => {
    if (!idSolicitudIngreso) return;
    if (isLoadingOrdenCompra && isLoadingSolicitudIngreso) return;
    if (form.getValues().solicitud_ingreso) {
      setProductosOrden([])
      setCodigosProductosLista([]) ////limpio para el filtro
      sumaCantidad()
    }

  }, [idSolicitudIngreso, dataOrdenCompra, form.watch("solicitud_ingreso")])
  ///seleciona solicitud_pedido
  useEffect(() => {
    if (!codigoSeleccionado) return;
    if (codigoSeleccionado && dataOrdenCompra) {
      setProductosOrden([])
      sumaCantidad()
    }
  }, [codigoSeleccionado, dataOrdenCompra])

  const sumaCantidad = () => {
    if (isLoadingOrdenCompra) return
    if (!dataOrdenCompra?.data.data.length) {
      setVerifica(true)
      return
    }

    const productos = dataOrdenCompra.data.data.reduce<TipoValores>((acumulado, orden) => {
      orden.detalles?.forEach((detalle) => {
        const codigo = detalle.codigo;
        const cantidad = Number(detalle.cantidad) || 0;

        acumulado[codigo] = (acumulado[codigo] || 0) + cantidad;
      });
      return acumulado;
    }, {});

    const resultado: solicitud_ingreso[] = Object.entries(productos).map(([codigo, cantidad]) => ({
      codigo,
      cantidad
    }))
    //return resultado
    setProductosOrden(resultado)
    setVerifica(true)
  }
  ///llama a la funcion de buscar el ultimo_precio_compra
  useEffect(() => {
    if (!codigoSeleccionado || !verifica) return;
    if (codigoSeleccionado && verifica === true) {
      buscarUltimoPrecio()
      setVerifica(false)
    }
  }, [codigoSeleccionado, productosOrden, verifica])

  //*****FUNCION PARA SETEAR LOS DATOS  */
  const buscarUltimoPrecio = () => {
    const solicitudCompra = SolicitudesIngresoPaging?.data.data.find(item => item.codigo === codigoSeleccionado)
    if (!solicitudCompra) return
    form.setValue('concepto', solicitudCompra.observaciones?.observacionSolicitante!)


    setIdSoliIngreso(solicitudCompra.id_solicitudingreso!)

    const productos = solicitudCompra?.productos
    /*   const codigos = productos?.map(item => item.codigo)
      if (!codigos?.length) return */
    setCodigosProductosLista(productos || [])
  }
  ///funcion que llama para cargar los datos en la tabla
  useEffect(() => {
    if (!codigosProductoLista || codigosProductoLista.length === 0) return
    if (!dataProductos || isLoadingProductos) return
    onChangeCompra()
  }, [codigosProductoLista, dataProductos])

  ///funcion onChnage
  const onChangeCompra = () => {
    const solicitudCompra = SolicitudesIngresoPaging?.data.data.find(item => item.codigo === codigoSeleccionado)
    if (!solicitudCompra) return
    setIdSoliIngreso(solicitudCompra.id_solicitudingreso!)

    const productos = solicitudCompra.productos

    if (productos?.length === 0 || !productos?.length) return;

    const aux: MaterialTransferido[] = productos.map((elemento) => {
      const productoEncontrado = productosOrden.find((prod) => prod.codigo === elemento.codigo);
      const productoData = dataProductos?.data.data.find(item => item.codigo === elemento.codigo);
      //const cantidadOriginal = Number(elemento.cantidad);
      const cantidadOriginal = Number(elemento.cantidad_aprobada)
      const restado = productoEncontrado ? Number(productoEncontrado.cantidad) : 0;
      const cantidadPendiente = cantidadOriginal - restado;
      //const descuento = cantidadPendiente * productoData?.pre
      return {
        id: elemento.id!,
        cantidad: cantidadPendiente,
        //cantidad: elemento.cantidad_aprobada!,
        contiene_serie: elemento.contiene_serie ?? false,
        codigo: elemento.codigo!,
        cantidad_recibida: 0,
        cantidad_aprobada: elemento.cantidad_aprobada!,
        cuentas_contables: [],
        series: [],
        producto_data: {
          codigo: elemento.producto_data?.codigo!,
          descripcion: elemento.producto_data?.descripcion!,
          categoria_producto: elemento.producto_data?.categoria_producto!,
          presentacion: elemento.producto_data?.presentacion,
          subcategoria_producto: elemento.producto_data?.subcategoria_producto,
          stock_actual: elemento.producto_data?.stock_actual,
          marca_producto: elemento.producto_data?.marca_producto,
          modelo_producto: elemento.producto_data?.modelo_producto,
          unidad_medida: elemento.producto_data?.unidad_medida
        },
        cantidad_pendiente: cantidadPendiente,
        precio_compra: 0,
        precio_total: 0,
        ultimo_precio_compra: productoData?.ultimo_precio_compra ?? '0.00',
        descuento: '0.00',
        subtotal_descuento: '0.00',
        iva_producto: '0.00',
        total_producto: '0.00',
        iva_porcentaje: '0.00'
      }
    })

    setAuxProductos(aux)
    const resp = aux.filter(item => Number(item.cantidad) > 0)
    const mensaje = productos?.length === 1 ? 'Producto agregado correctamente' : 'Productos agregados correctamente'
    setAlert(true, mensaje, AlertSeverityEnum.success)
    handldeCopiarLista(resp)

  }


  ////viene con ID
  useEffect(() => {
    if (isLoadingSolicitudIngreso) return;
    if (!idSolicitudIngreso || !dataProductos?.data.data) return;
    if (isLoadingOrdenCompra && isLoadingSolicitudIngreso) return;
    if (!verifica) return
    if (verifica === true) {
      ///compraID()
      buscarUltimoPrecioID()

    }
    form.setValue('concepto', dataSolicitudIngreso?.data.observaciones?.observacionSolicitante!)
    // compraID()
  }, [idSolicitudIngreso, dataSolicitudIngreso, productosOrden, verifica, dataProductos])

  /////******** Funcion para buscar los productos
  const buscarUltimoPrecioID = () => {
    if (isLoadingSolicitudIngreso && isRefetching) return
    const producto = dataSolicitudIngreso?.data.productos
    setCodigosProductosLista(producto || [])
  }

  ///***funcion para construir el objeto */
  useEffect(() => {
    if (!codigosProductoLista || codigosProductoLista.length === 0) return
    if (!dataProductos || isLoadingProductos) return
    compraID()
  }, [codigosProductoLista, dataProductos])

  ///funcion compra
  const compraID = () => {

    if (isLoadingSolicitudIngreso && isRefetching) return;
    const producto = dataSolicitudIngreso?.data.productos
    if (!producto?.length || producto.length === 0) return;

    const aux: MaterialTransferido[] = producto.map((elemento) => {

      const productoEncontrado = productosOrden.find(item => item.codigo === elemento.codigo);
      const productoData = dataProductos?.data.data.find(item => item.codigo === elemento.codigo);
      const cantidadOriginal = Number(elemento.cantidad_aprobada)
      //const cantidadOriginal = Number(elemento.cantidad);
      const restado = productoEncontrado ? Number(productoEncontrado.cantidad) : 0;
      const cantidadFinal = cantidadOriginal - restado

      return {
        id: elemento.id!,
        cantidad: cantidadFinal,
        contiene_serie: elemento.contiene_serie ?? false,
        codigo: elemento.codigo!,
        cantidad_recibida: 0,
        cantidad_aprobada: elemento.cantidad_aprobada!,
        cuentas_contables: [],
        series: [],
        producto_data: {
          codigo: elemento.producto_data?.codigo!,
          descripcion: elemento.producto_data?.descripcion!,
          categoria_producto: elemento.producto_data?.categoria_producto!,
          presentacion: elemento.producto_data?.presentacion,
          subcategoria_producto: elemento.producto_data?.subcategoria_producto,
          stock_actual: elemento.producto_data?.stock_actual,
          modelo_producto: elemento.producto_data?.modelo_producto,
          marca_producto: elemento.producto_data?.marca_producto,
          unidad_medida: elemento.producto_data?.unidad_medida
        },
        cantidad_pendiente: cantidadFinal,
        precio_compra: 0,
        precio_total: 0, ///subtotal por items
        ultimo_precio_compra: productoData?.ultimo_precio_compra ?? '0.00',
        descuento: '0.00',
        subtotal_descuento: '0.00',
        iva_producto: '0.00',
        total_producto: '0.00',
        iva_porcentaje: '0.00'
      }
    })

    setAuxProductos(aux)
    const resp = aux.filter(item => Number(item.cantidad) > 0)
    setAlert(true, 'Producto agregados correctamente.', AlertSeverityEnum.success)
    handldeCopiarLista(resp)
  }

  ///funtion for set value
  const onChangeProveedor = (value: string) => {

    form.setValue("proveedor", value);
    const resp = ProveedorPaging?.data.data.find(item => item.codigo === value!)
    setEdit(resp?.id_proveedor!)
    form.setValue("email", resp?.email)
    form.setValue("contacto_telefono_1", resp?.contacto_telefono_1 || 'N/A')
    if (!value) {
      form.reset({
        contacto_telefono_1: (''),
        email: ('')
      })
    }
  };
  ///metodo pago
  const onChangeFormaPago = (value: string) => {
    form.setValue("forma_pago", value);
    const metodoSelecionado = formaPagoPaging?.data?.data.find(item => item.codigo === value)
    if (metodoSelecionado?.nombre === "MIXTO") {
      setIsModalPago(true)
      setPagoMixto(metodoSelecionado?.nombre)

    } else {
      setIsModalPago(false)
      clearMetodoPago()
      setPagoMixto('')
    }
  };
  ///ultimo_precio_compra

  ////////************************MUTATION***********/
  const onSave = async () => {
    //console.log('producto_data',)

    //return
    if (productos.length === 0)
      return setAlert(true, 'Seleccione al menos un producto.', AlertSeverityEnum.error)
    ///verifica que el valor sea mayor en la cantidad requerida
    const resp = productos.find(item => Number(item.cantidad) <= 0)
    if (resp) {
      setAlert(true, `El producto "${resp?.codigo}", tiene una cantidad inválida, debe ser mayor a cero.`, AlertSeverityEnum.error)
      return
    }
    const resul = productos.find(item => Number(item.precio_compra) <= 0)
    if (resul) {
      setAlert(true, `El producto "${resul?.codigo}", tiene un "valor unitario" inválida, debe ser mayor a cero.`, AlertSeverityEnum.error)
      return
    }


    //****** cerrar el orden
    const productosOriginal = auxProductos.filter(item => item.cantidad_pendiente! > 0)

    const productosFaltantes = productosOriginal.filter(item => {
      const producto = productos.find(prod => prod.codigo === item.codigo)
      if (!producto) return true;
      const diferencia = Number(producto.cantidad_pendiente!) - Number(producto.cantidad)
      return diferencia > 0
    })
    ////*******Valida forma pago
    const formaPagoMixto = form.getValues('forma_pago')
    // console.log('validamos', formaPagoMixto)
    const existeFormaMixto = formaPagoPaging?.data?.data.find(item => item.codigo === formaPagoMixto)


    ///****cargar imagen o documento
    const isImage = archivo?.type.startsWith("image/")
    const bucketDestino = isImage
      ? BucketAwtENUM.IMAGE_ORDEN_COMPRA
      : BucketAwtENUM.DOCUMENTO_ORDEN_COMPRA
    const archivo1 = (await handleUploadFile(archivo!, bucketDestino)).url

    const prod = productos.map(item => ({
      ...item,
      precio_total: (Number(item.cantidad) * Number(item.precio_compra)).toFixed(4),
      subtotal_descuento: (Number(item.cantidad) * Number(item.precio_compra) - Number(item.descuento)).toFixed(4),
      iva_producto: ((Number(item.cantidad) * Number(item.precio_compra) - Number(item.descuento)) * totalesOrden.iva_producto).toFixed(4),
      total_producto: ((Number(item.cantidad) * Number(item.precio_compra) - Number(item.descuento)) * totalesOrden.iva_producto + Number(item.cantidad) * Number(item.precio_compra) - Number(item.descuento)).toFixed(4),
      iva_porcentaje: (totalesOrden.iva_producto).toFixed(2)
    }))

    //producto
    const validDescuento = prod.find(item => Number(item.descuento) > Number(item.precio_total))
    if (validDescuento) return toast.error(`El producto (${validDescuento?.codigo}) tiene un descuento mayor que el subtotal(${validDescuento.precio_total}). Por favor, verifique el valor ingresado.`)
    ///trasformacion a objeto
    const mix_pagos = metodoPago.reduce((acumulador, item) => {
      acumulador[item.metodo] = item.valor;
      return acumulador
    }, {} as any)
    ///
    if (existeFormaMixto?.nombre === TipoFormaPagoEnumChoice.MIXTO) {
      if (Object.keys(mix_pagos).length === 0) {
        toast.error('La forma de pago que seleccionaste es Mixto, para ello debes asignar los métodos de pago.')
        return;
      }
    }

    ///****** datos
    const ordenCompra: any = {
      ...form.getValues(),
      fecha_compra: dayjs(form.getValues().fecha_compra).format('YYYY-MM-DD HH:mm:ss'),
      fecha_entrega: dayjs(form.getValues().fecha_entrega).format('YYYY-MM-DD HH:mm:ss'),
      fecha_orden: dayjs(form.getValues().fecha_compra).format('YYYY-MM-DD HH:mm:ss'),
      detalles: prod,
      mix_pagos: mix_pagos,
      observaciones: {
        observacionCreador: form.getValues().observaciones?.observacionCreador,
        observacionRevisor: '',
      },
      urls_imagenes: {
        urlOrden: archivo1,
        urlOrdenRevision: ''
      },
      subtotal: totalesOrden.subtotal.toFixed(4),
      iva: totalesOrden.iva.toFixed(4),
      total: totalesOrden.total.toFixed(4),
      descuento: totalesOrden.totalDescuento.toFixed(4),
      iva_porcentaje: Math.round((totalesOrden.iva_producto * 100))
      //iva_porcentaje: totalesOrden.iva_producto * 100
    }
    /* console.log('Json', ordenCompra)
    return; */
    //update
    if (editOrdenesCompra) {
      const resp = await updateOrdenCompra.mutateAsync({
        id: editOrdenesCompra.id_orden_compra!,
        data: {
          ...ordenCompra,
          url_pdf: null
        }
      })
    
      if (resp.code !== 200) return;
      reset(); // reset form after successful creation
      clearSelectedItems()
      clearMetodoPago();
      navigate(ROUTER_PATHS.compras.orden_compras_nav)
      return

    }
    ///******** mutation
    if (productosFaltantes.length > 0) {
      //console.log('Aún hay productos pendientes, no se puede cerrar.');
      const resulOrdenCompra = await createOrdenesCompraMutation.mutateAsync(ordenCompra)
      if (resulOrdenCompra.code !== 200) return;
      reset(); // reset form after successful creation
      clearSelectedItems()
      clearMetodoPago()
      navigate(ROUTER_PATHS.compras.orden_compras_nav)
    } else {
      setConfirmDialogIsOpen(true)
      setConfirmDialog({
        cancelTextBtn: 'Cancelar',
        isOpen: true,
        title: " ✓ Solicitud completada",
        subtitle: "Esta solicitud se ha completado con éxito. **Esta es la última vez que podrás generar la orden con este número de solicitud.** Al confirmar, se procederá a finalizar el proceso.",
        onClose() {
          setConfirmDialogIsOpen(false)
        },
        onConfirm: async () => {
          setConfirmDialogIsOpen(false)
          const resulOrdenCompra = await createOrdenesCompraMutation.mutateAsync(ordenCompra)
          if (resulOrdenCompra.code !== 200) return;
          if (idSolicitudIngreso || idSoliIngreso) {
            const idFinalIngreso = idSolicitudIngreso || idSoliIngreso
            const revisionSolicitudPedido: any = {
              id: idFinalIngreso,
              data: {
                estado_solicitud: EstadosSolicitudIngresoEnum.FINALIZADO
              }
            }
            await updateSolicitudesIngresos.mutateAsync(revisionSolicitudPedido)
          }
          reset(); // reset form after successful creation
          clearSelectedItems()
          clearMetodoPago();
          navigate(ROUTER_PATHS.compras.orden_compras_nav)

        }
      })

    }
  }
  //limpieza
  useEffect(() => {
    if (!isChecked) {
      clearSelectedItems()
    }
  }, [isChecked])
  /*   if(isLoadingProducto) return <LoaderComponent/> */
  ///update
  useEffect(() => {
    if (editOrdenesCompra) {
      setIsChecked(true)

      reset({
        ...editOrdenesCompra,
        contacto_telefono_1: editOrdenesCompra.proveedor_data?.contacto_telefono_1,
        email: editOrdenesCompra.proveedor_data?.email,
      } as any)
      if (editOrdenesCompra.detalles) {
        const aux = editOrdenesCompra.detalles.map((elemento: any) => ({
          ...elemento,

        }))
        handldeCopiarLista(aux)

        const ivaPorcentaje = Math.round(Number((editOrdenesCompra as any)?.detalles[0]?.iva_porcentaje) * 100)
    
        setEditIva(ivaPorcentaje)
      }

      const urlOrdenPdf = editOrdenesCompra?.urls_imagenes?.urlOrden

      if (urlOrdenPdf) {
        const extension = urlOrdenPdf.split('.').pop()?.toLowerCase()
        let tipoArchivo = 'aplication/pdf';
        let nombreArchivo = 'respaldo-aprobación.pdf';

        if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension!)) {
          tipoArchivo = `image/${extension === 'jpg' ? 'jpeg' : extension}`;
          nombreArchivo = `respaldo-aprobación.${extension}`;
        }

        setArchivo({
          preview: urlOrdenPdf,
          name: nombreArchivo,
          type: tipoArchivo,
        } as any)
      }

    }
  }, [editOrdenesCompra])


  return (
    <>
      <SingleTableBoxScene
        title={titlePage}
        enableBackBtn={true}
        backPageUrl={ROUTER_PATHS.compras.orden_compras_nav}
        visibleReport={false}
        enableCreateOrEditBtn={true}
        fnCreateOrEdit={handleSubmit(onSave,
          (e) => { console.log(e) }
        )}
      >
        <Grid container spacing={3}>
          <SampleDatePicker
            label="Fecha Orden de Compra"
            name="fecha_orden"
            textFieldKey="fecha_orden"
            defaultValue={today}
            control={form.control}
            error={errors.fecha_orden}
            helperText={errors.fecha_orden?.message}
            size={gridSizeMdLg4}
            minDate={today}
            maxDate={today}
            disabled={true}
          />
          <SampleDatePicker
            label="Fecha Estimada de Compra"
            control={form.control}
            error={errors.fecha_compra}
            helperText={errors.fecha_compra?.message}
            name="fecha_compra"
            textFieldKey="fecha_compra"
            size={gridSizeMdLg4}
            defaultValue={new Date().toISOString()}
            minDate={new Date().toISOString()}
          />
          <SampleDatePicker
            label="Fecha Estimada de Entrega"
            control={form.control}
            error={errors.fecha_entrega}
            helperText={errors.fecha_entrega?.message}
            name="fecha_entrega"
            textFieldKey="fecha_entrega"
            size={gridSizeMdLg4}
            defaultValue={new Date().toISOString()}
            minDate={fecha_compra}
          />
          {form.getValues().concepto && (
            <CustomModalObservacionForm
              name="concepto"
              label="Concepto"
              title="Motivo Compra"
              control={form.control}
              size={gridSizeMdLg4}
            />
          )}

          <CustomAutocomplete<PROVEEDOR>
            label="Proveedor"
            name="proveedor"
            // options
            options={ProveedorPaging?.data.data || []}
            valueKey="razon_social" // name is the fk
            actualValueKey="codigo"
            defaultValue={form.getValues().proveedor || ""}
            isLoadingData={isLoadingProveedor}
            control={control}
            error={errors.proveedor}
            helperText={errors.proveedor?.message}
            onChangeValue={onChangeProveedor}
            size={gridSizeMdLg4}

          />

          <CustomTextField
            label="Contacto Proveedor"
            name="contacto_telefono_1"
            control={form.control}
            error={errors.contacto_telefono_1}
            helperText={errors.contacto_telefono_1?.message}
            size={gridSizeMdLg4}
            disabled={true}
          //defaultValue={form.getValues().contacto_telefono_1 || 'N/A'}
          />

          <CustomEmailEditTextFiel
            label="Email Proveedor"
            name="email"
            control={form.control}
            defaultValue={""}
            error={errors.email}
            helperText={errors.email?.message}
            size={gridSizeMdLg4}
            shrink={true}
            onEditChange={(e) => {
              //console.log('e', e)
              if (!e) {
                return updateProveedor.mutate({
                  id: idEdit!,
                  data: { email: form.getValues().email } as any
                })
              }
            }}
            disabled={true}
          />


          <CustomAutocomplete<IPaymentMethod>
            label="Forma de pago"
            name="forma_pago"
            //// options
            options={formaPagoPaging?.data?.data || []}
            // label & search by name
            valueKey="nombre"
            actualValueKey="codigo"
            //
            defaultValue={form.getValues().forma_pago || ""}
            optionLabelForEdit={form.getValues().forma_pago || ""}
            isLoadingData={isLoadingFormaPagoPaging}
            //// validation
            control={control}
            error={errors.forma_pago}
            helperText={errors.forma_pago?.message}
            onChangeValue={onChangeFormaPago}
            size={gridSizeMdLg4}
          />
          <CustomTextField
            name="plazo_pago"
            label="Plazo de pago"
            control={form.control}
            defaultValue={form.getValues().plazo_pago || ""}
            error={errors.plazo_pago}
            helperText={errors.plazo_pago?.message}
            shrink={shrink}
            size={gridSizeMdLg4}
          />

          {!idSolicitudIngreso && (
            <Grid item {...gridSizeMdLg4}>
              <SampleCheckboxNoForm
                label="¿Incluir solicitudes de compra aprobadas?"
                defaultValue={editOrdenesCompra ? true : false}
                onChangeValue={(e) => {

                  setIsChecked(e!)
                  if (!e) {
                    form.setValue("solicitud_ingreso", "");
                  }
                }}
              />
              <Typography variant="caption" color="textSecondary" sx={{ ml: 4, display: 'block', fontStyle: 'italic' }}>
                {"Active esta opción si requiere seleccionar una solicitud existente."}
              </Typography>

            </Grid>

          )}

          {isLoadingSolicitudIngreso ? (
            <CircularProgress />
          ) : (

            (idSolicitudIngreso || isChecked) && (
              <CustomAutocomplete<SolicitudesIngreso>
                label=" Solicitud de Compra"
                name="solicitud_ingreso"
                // options
                options={SolicitudesIngresoPaging?.data.data || []}
                valueKey="codigo"
                actualValueKey="codigo"
                defaultValue={form.getValues().solicitud_ingreso || ""}
                isLoadingData={isLoadingSolicitudesIngresoPaging}
                control={control}
                error={errors.solicitud_ingreso}
                helperText={errors.solicitud_ingreso?.message}
                onChangeValue={(value) => { setCodigoSeleccionado(value) }/* onChangeSolicitudIngreso */}
                size={gridSizeMdLg4}
                disabled={!!idSolicitudIngreso}
              />

            )

          )}

          <Grid item {...gridSizeMdLg4}>
            <TextField
              variant="outlined"
              label="Observación "
              multiline
              rows={2}
              fullWidth
              {...form.register("observaciones.observacionCreador")}
              error={!!errors.observaciones?.observacionCreador}
              helperText={errors.observaciones?.observacionCreador?.message}
              InputLabelProps={{
                shrink: true
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <TabTextLabel text={'Respaldo de aprobación'} mt={0} pb={0} pl={0} pt={2} />
          </Grid>

          <Grid item {...gridSizeMdLg4}>
            <CargarDocumentoSoluccionCosteada
              idInput='documento-orden-pedido'
              buttonText={'Respaldo de Aprobación'}
              selectedImage={archivo}
              setSelectedImage={setArchivo}
              accept=".pdf, .png, .jpg, .jpeg"
              tiposPermitidos={["application/pdf", "image/*"]}
              permiteImagen={true}
            />
          </Grid>

          <Grid item {...gridSize}>
            <Paper className="paper-producto">
              <Grid container spacing={1} justifyContent={"space-between"} alignItems={"center"}>
                <Grid><TabTextLabel text="Items Seleccionado" mt={0} pb={0} pl={0} pt={0} /></Grid>
                <div className="linea"></div>
                <Grid item xs={12} mt={2}>
                  <SampleTablePaginationOrden
                    columns={columnsOrdenCompra}
                    data={paginatedData}
                    allData={productos}
                    rowCount={productos.length}
                    setPagination={setPagination}
                    pagination={pagination}
                    rowNumber={true}
                    //activacion de totales
                    enableSubTotalCalculation={true}
                    enableTaxSelection={true}
                    onTotalsChange={(totals) => setTotalesOrden(totals)}
                    initialTaxtPorcentaje={editIva}
                  //totalField="precio_compra"
                  />
                </Grid>

              </Grid>

            </Paper>

          </Grid>

        </Grid>

      </SingleTableBoxScene>

      < ModalMetodoPagoMixto
        isModalPago={isModalPago}
        setIsModalPago={setIsModalPago}
        valores={totalesOrden.subtotal}
        nombre={pagoMixto}
      />
    </>
  )
}
export default SaveOrdenesCompra